/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-unused-vars */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import ReactPlayer from 'react-player';
import parse from 'html-react-parser';
import { isMobile } from 'react-device-detect';

class TopEventBanner extends Component {
  state = {
    playing: false,
    playIndex: 0,
    currentPlayIndex: 0,
    mute: true,
    playUrl: '',
    imgShow: false,
  };
  _isMounted = true;
  _isReload = false;
  componentDidMount = () => {
    this._isMounted = true;
    this._getBanner();
    this._getWindowSize();
    window.addEventListener('resize', this._getWindowSize);
    //console.log('didmount')
  };

  UNSAFE_componentWillReceiveProps = (nextProps, nextState) => {
    // return false 하면 업데이트를 안함
    return this.props.childProps.param !== nextProps.childProps.param;
    //return true;
  };
  componentWillReceiveProps = (nextProps) => {
    //console.log(this.props.childProps.param)
    //console.log(nextProps.childProps.param)
    //console.log(this._isReload)
    if (this.props.childProps.param !== nextProps.childProps.param) {
      if (this._isReload) {
        this.setState({
          playing: false,
          playIndex: 0,
          currentPlayIndex: 0,
          mute: true,
          playUrl: '',
          imgShow: false,
        });
        this._getBanner();
      }

      //console.log('willReceive')

      //this._getWindowSize()
    }
  };

  componentWillUnmount = () => {
    this._isMounted = false;
    window.removeEventListener('resize', this._getWindowSize);
  };
  _getBanner = async () => {
    const result = await this._getBannerApi();
    const intReturn = result.data[0].intReturn;
    const eventData = result.data[0].listData;

    if (intReturn === 0) {
      let videoList = [];
      //console.log(eventData[0].vodUrl)
      if (
        eventData[0].vodUrl !== null &&
        eventData[0].vodUrl !== null &&
        eventData[0].vodUrl !== undefined
      ) {
        videoList.push({ url: eventData[0].vodUrl });
      }

      //console.log(videoList)
      if (this._isMounted) {
        this.setState({
          eventData,
          videoList,
        });
        setTimeout(() => {
          this._onPlayVideo();
        }, 800);
      }

      this._bannerView(
        eventData[0].idx,
        eventData[0].adComIdx,
        eventData[0].pageCode
      );
      //노출수
      //console.log('==> 베너 노출')
      //console.log(eventData[0].idx, eventData[0].adComIdx)

      //videoList.push({url: 'https://jjmp4.ofscdn.com/PV/' + eventData[0].vodUrl})
    }
  };
  _getBannerApi = () => {
    const { apiUrl } = this.props;

    return axios(apiUrl + '/topBannerEvent')
      .then((response) => response)
      .catch((error) => {
        //console.log('error....')
      });
  };
  _bannerView = async (idx, adComIdx, pageCode) => {
    if (adComIdx === null || adComIdx === undefined || adComIdx === '') {
    } else {
      if (adComIdx !== 1) {
        const result = await this._bannerViewApi(idx, adComIdx, pageCode);
        const intReturn = result.data[0].intReturn;

        if (intReturn === 0) {
          //console.log('banner view history...')
        }
      }
    }
  };
  _bannerViewApi = (idx, adComIdx, pageCode) => {
    const { apiUrl, loginId } = this.props;

    return axios.post(apiUrl + '/bannerView', {
      params: {
        userid: loginId,
        idx: idx,
        adComIdx: adComIdx,
        pageCode: pageCode,
      },
    });
  };
  _bannerClickApi = (idx, adComIdx, pageCode) => {
    const { apiUrl, loginId } = this.props;

    return axios.post(apiUrl + '/bannerClick', {
      params: {
        userid: loginId,
        idx: idx,
        adComIdx: adComIdx,
        pageCode: pageCode,
      },
    });
  };
  _onClick = async () => {
    const { history, setEventIdx } = this.props;
    const { eventData } = this.state;
    const url = eventData[0].LinkURL;
    const url_M = eventData[0].LinkURL_M;
    const idx = eventData[0].idx; //bannerIdx
    const contentSerial = eventData[0].contentSerial;
    const adComIdx = eventData[0].adComIdx;
    const pageCode = eventData[0].pageCode;

    if (adComIdx !== 1) {
      const result = await this._bannerClickApi(idx, adComIdx, pageCode);
      const intReturn = result.data[0].intReturn;
    }

    //if(intReturn === 0) {
    if (contentSerial === -1) {
      if (isMobile) {
        setEventIdx(parseInt(url_M));
      } else {
        setEventIdx(parseInt(url));
      }
    } else {
      if (idx === 76) {
        history.push('/tlist?ts=2');
      } else {
        if (isMobile) {
          if (eventData[0].Linktarget_M === '_blank') {
            window.open(url_M, '', '');
          } else {
            history.push(url_M);
          }
        } else {
          if (eventData[0].Linktarget === '_blank') {
            window.open(url, '', '');
          } else {
            history.push(url);
          }
        }
      }
    }
    //}

    /*
        if(idx === 75) {
            setEventIdx(278)
        } else if(idx === 76) {
            history.push('/tlist?ts=2')
        } else if(idx === 77){
            setEventIdx(279)
        } else {
            if(eventData[0].Linktarget === '_blank') {
                window.open(url, '', '')
            } else {
                history.push(url)
            }
        }
        */
  };
  _onPlayVideo = () => {
    const { videoList, playIndex } = this.state;
    let currentPlayIndex;
    //console.log(videoList)

    if (videoList) {
      const playLenght = videoList.length;

      //console.log(playIndex, playLenght)
      //console.log(videoList)
      if (playLenght <= 0) {
        this.setState({
          playing: false,
          imgShow: true,
        });
      } else {
        if (playIndex >= playLenght) {
          //썸네일??? 고정!!!
          //currentPlayIndex = 0
          this.setState({
            playing: false,
            imgShow: true,
            //playUrl: videoList[currentPlayIndex].url,
            //playIndex: currentPlayIndex + 1,
            //currentPlayIndex: currentPlayIndex
          });
          this._isReload = true;
        } else {
          ////console.log(videoList[currentPlayIndex].url)
          currentPlayIndex = playIndex;

          this.setState({
            playing: true,
            playUrl: videoList[currentPlayIndex].url,
            playIndex: currentPlayIndex + 1,
            currentPlayIndex: currentPlayIndex,
          });
        }
      }
    }
  };
  _onReady = () => {
    this.setState({
      playing: true,
    });
  };
  _onEnded = () => {
    ////console.log('end')
    //애니플러스 로그 재생 후
    this._onPlayVideo();
  };
  _getWindowSize = () => {
    //console.log(window.innerWidth)
    const hSize = (window.innerWidth - 18) * (1080 / 1920);
    this.setState({
      wSize: window.innerWidth - 18,
      hSize: hSize,
    });
  };
  render() {
    const {
      eventData,
      playing,
      playUrl,
      videoList,
      imgShow,
      wSize,
      hSize,
      mute,
    } = this.state;
    const { imgUrl } = this.props;
    //console.log(eventData ? eventData[0].idx : null)
    return (
      <Fragment>
        {eventData ? (
          imgShow ? (
            <div
              className="top_baner"
              // style={isMobile ? { 'padding-bottom': 30 } : {}}
            >
              <div
                className={
                  eventData[0].part === 'movie' ? 'text_group2' : 'text_group3'
                }
              >
                <h1>
                  {isMobile ||
                  eventData[0].bannerFile_s === null ||
                  eventData[0].bannerFile_s === undefined ||
                  eventData[0].bannerFile_s === '' ? null : (
                    <img
                      src={
                        'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/banner/' +
                        eventData[0].bannerFile_s
                      }
                    />
                  )}
                  <span>{eventData[0].title}</span>
                  <p>{parse(eventData[0].comment)}</p>
                </h1>

                {eventData[0].part === 'collabo' ? (
                  <Fragment>
                    {/*<p>{eventData[0].openDay}</p>*/}
                    <div
                      className="p_btn3"
                      style={{ cursor: 'pointer' }}
                      onClick={this._onClick}
                    >
                      <span>자세히보기</span>
                    </div>
                  </Fragment>
                ) : eventData[0].part === 'movie' ? (
                  isMobile ? null : (
                    <div className="p_btn2">
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={this._onClick}
                      >
                        예매하기
                      </span>
                      <strong>{eventData[0].openDay}</strong>
                      <em>({eventData[0].openDay1})</em>
                    </div>
                  )
                ) : (
                  <div
                    className="p_btn3"
                    style={{ cursor: 'pointer' }}
                    onClick={this._onClick}
                  >
                    <span>자세히보기</span>
                  </div>
                )}

                {/*
                            {eventData[0].idx === 75 ? <p>9.24 OPEN</p> : null }
                            {eventData[0].idx === 83 ? <p>10.15 OPEN</p> : null }
                            {eventData[0].idx === 128 ? <p>06.10 OPEN</p> : null }
                           
                            
                            {eventData[0].idx === 88 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>2020.10.22 메가박스 대개봉</strong><em>(15세 관람가)</em></div>
                            ) : eventData[0].idx === 92 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>11월26일 메가박스 단독 개봉</strong><em>(15세 관람가)</em></div>
                            ) : eventData[0].idx === 112 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>2월 25일 개봉</strong><em>(15세 관람가)</em></div>
                            ) :  eventData[0].idx === 116 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>3월 11일 CGV 4DX 대개봉</strong><em>(15세 관람가)</em></div>
                            ) : eventData[0].idx === 126 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>6월 3일 메가박스 대개봉</strong><em>(전체 관람가)</em></div>
                            ) : eventData[0].idx === 150 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>8월 26일 메가박스 대개봉</strong><em>(15세 관람가)</em></div>
                            ) : eventData[0].idx === 159 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>9월 9일 메가박스 대개봉</strong><em>(전체 관람가)</em></div>
                            ) : eventData[0].idx === 181 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>11월 18일 메가박스 대개봉</strong><em>(전체 관람가)</em></div>
                            ) : eventData[0].idx === 189 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>12월 09일 CGV 대개봉</strong><em>(12세 관람가)</em></div>
                            ) : (
                                <div className="p_btn3" style={{cursor: 'pointer'}} onClick={this._onClick}><span>자세히보기 <img src="/img/more4.png"/></span></div>
                            ) }
                            */}
              </div>
              <div className="bg_img2"></div>
              <div className="bg_img">
                <img
                  src={
                    'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/banner/' +
                    eventData[0].bannerFile
                  }
                />
              </div>
            </div>
          ) : (
            <div
              className="top_baner"
              // style={isMobile ? { 'padding-bottom': 30 } : {}}
            >
              <div
                className={
                  eventData[0].part === 'movie' ? 'text_group2' : 'text_group3'
                }
              >
                <h1>
                  {eventData[0].bannerFile_s === null ||
                  eventData[0].bannerFile_s === undefined ||
                  eventData[0].bannerFile_s === '' ? null : (
                    <img
                      src={
                        'https://bc8azosk4j.ecn.cdn.ofs.kr/aniplustv/banner/' +
                        eventData[0].bannerFile_s
                      }
                    />
                  )}
                  <span>{eventData[0].title}</span>
                  <p>{parse(eventData[0].comment)}</p>
                </h1>
                {eventData[0].part === 'movie' ? (
                  isMobile ? null : (
                    <div className="p_btn2">
                      <span
                        style={{ cursor: 'pointer' }}
                        onClick={this._onClick}
                      >
                        예매하기
                      </span>
                      <strong>{eventData[0].openDay}</strong>
                      <em>({eventData[0].openDay1})</em>
                    </div>
                  )
                ) : (
                  <div
                    className="p_btn3"
                    style={{ cursor: 'pointer' }}
                    onClick={this._onClick}
                  >
                    <span>자세히보기</span>
                  </div>
                )}

                {/* eventData[0].idx === 112 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>2월 25일 대개봉</strong><em>(15세 관람가)</em></div>
                            ) : eventData[0].idx === 116 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>3월 11일 CGV 4DX 대개봉</strong><em>(15세 관람가)</em></div>
                            ) : eventData[0].idx === 126 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>6월 3일 메가박스 대개봉</strong><em>(전체 관람가)</em></div>
                            ) : eventData[0].idx === 150 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>8월 26일 메가박스 대개봉</strong><em>(15세 관람가)</em></div>
                            ) :  eventData[0].idx === 159 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>9월 9일 메가박스 대개봉</strong><em>(전체 관람가)</em></div>
                            ) :  eventData[0].idx === 181 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>11월 18일 메가박스 대개봉</strong><em>(전체 관람가)</em></div>
                            ) :  eventData[0].idx === 189 ? (
                                <div className="p_btn2"><span style={{cursor: 'pointer'}} onClick={this._onClick}>예매하기 <img src="/img/more4.png"/></span><strong>12월 09일 CGV 대개봉</strong><em>(12세 관람가)</em></div>
                            ) : (
                                <div className="p_btn3" style={{cursor: 'pointer'}} onClick={this._onClick}><span>자세히보기 <img src="/img/more4.png"/></span></div>
                            ) */}
              </div>
              <div className="bg_img2"></div>
              <div className="bg_img" onClick={this._onClick}>
                {/*<div className="s_img1"><img src="/img/mueum.png" style={{}}/></div>*/}
                <ReactPlayer
                  //url={'https://jjmp4.ofscdn.com' + liveData[0].opening}
                  className="bg_img"
                  playing={playing}
                  url={playUrl}
                  volume={0.2}
                  muted={mute}
                  onReady={this._onReady}
                  onEnded={this._onEnded}
                  style={{ width: wSize, height: hSize }}
                  width={wSize}
                  height={hSize}
                />
              </div>
            </div>
          )
        ) : null}
      </Fragment>
    );
  }
}

export default shopContext(withRouter(TopEventBanner));
